var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "field",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "label",
              fn: function () {
                return [_vm._t("label")]
              },
              proxy: true,
            },
            {
              key: "field-description",
              fn: function () {
                return [_vm._t("field-description")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "field",
      { ..._vm.$attrs, ..._vm.$props },
      false
    ),
    [
      _vm._v(" "),
      !_vm.readOnly
        ? _c("div", { class: _vm.selectWrapperClasses }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model",
                  },
                ],
                ref: "input",
                attrs: {
                  id: _vm.fieldId,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  "data-qa": "option-field-select",
                },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.model = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.onChange,
                  ],
                },
              },
              [
                _vm.showPlaceholder
                  ? _c(
                      "option",
                      {
                        attrs: {
                          selected: "",
                          disabled: "",
                          hidden: "",
                          "data-qa": "option-field-option-placeholder",
                        },
                        domProps: { value: null },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.placeholder ||
                                _vm.Resources.Common.PleaseSelectPlaceholder
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.optionsArray, function (option) {
                  return _c(
                    "option",
                    {
                      key: option.name,
                      attrs: {
                        "data-qa": `option-field-option:${option.value}`,
                      },
                      domProps: { value: option.value },
                    },
                    [_vm._v(_vm._s(option.name))]
                  )
                }),
              ],
              2
            ),
          ])
        : _c("input", {
            class: [
              "gfu-field__input gfu-field__input--readonly",
              { "gfu-field__input--small": _vm.small },
            ],
            attrs: {
              id: _vm.fieldId,
              type: "text",
              readonly: _vm.readOnly,
              name: _vm.name,
              "data-qa": "input-field",
            },
            domProps: {
              value:
                _vm.optionsArray.find((option) => option.value === _vm.model)
                  ?.name || _vm.readOnlyPlaceholder,
            },
          }),
      _vm._v(" "),
      _vm._t("additional-field-info"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }